import { Box } from "@dealer-center/core-components";
import type { ComponentType } from "react";
import { DemoNav } from "../DemoNav";

interface Props {
  Component: ComponentType;
}

export const SingleLayout = ({ Component }: Props) => (
  <Box
    sx={{
      height: "calc(100vh - 115px)",
      overflowY: "auto",
      position: "fixed",
      top: "115px",
      width: "100%"
    }}
  >
    <DemoNav />
    <Box sx={{ borderColor: "divider", borderTop: "1px solid" }}>
      <Component />
    </Box>
  </Box>
);
